<template>

	<div id="app">
		<OrientalMagic></OrientalMagic>
	</div>
	
</template>



<script>

import OrientalMagic from './components/OrientalMagic.vue'

export default {
	name: 'app',
	components: {
		OrientalMagic
	}
}

</script>



<style lang="scss">

#app {
	font-family: 'Gentium Basic', serif;
	font-size: 100%;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
